// import { Box, Button, Chip, LinearProgress, Typography } from '@mui/material'
// import AccessTimeIcon from '@mui/icons-material/AccessTime'
// import ChecklistIcon from '@mui/icons-material/Checklist'
// import AddIcon from '@mui/icons-material/Add'
// import { DragDropContext, Draggable, Droppable, type DropResult } from '@hello-pangea/dnd'
// import {
//   PRIORITIES,
//   STATUSES,
//   USER_BY_ID,
//   checklistProgress,
//   formatDue,
//   formatMinutes,
//   type StatusId,
//   type TodoTask,
// } from './Tododata.ts'
// import UserAvatar from './Useravtar.tsx'

// interface Props {
//   tasks: TodoTask[] // already filtered
//   onMove: (taskId: string, toStatus: StatusId, beforeId: string | null) => void
//   onOpen: (task: TodoTask) => void
//   onCreate: (status: StatusId) => void
// }

// function TaskCard({ task, dot, isDragging }: { task: TodoTask; dot: string; isDragging: boolean }) {
//   const user = USER_BY_ID[task.assigneeId]
//   const pri = PRIORITIES[task.priority]
//   const { done, total } = checklistProgress(task)
//   const pct = total ? (done / total) * 100 : 0

//   return (
//     <Box
//       sx={{
//         bgcolor: '#fff',
//         border: '1px solid #E2DFD0',
//         borderRadius: '10px',
//         p: 1.5,
//         display: 'flex',
//         flexDirection: 'column',
//         gap: 1.25,
//         cursor: 'grab',
//         boxShadow: isDragging ? '0 8px 20px rgba(37,36,26,0.25)' : '0 1px 2px rgba(37,36,26,0.08)',
//       }}
//     >
//       <Typography sx={{ fontSize: 14, fontWeight: 600, lineHeight: 1.4, color: '#25241A' }}>{task.title}</Typography>

//       <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
//         {task.labels.map((label) => (
//           <Chip key={label} size="small" label={label} sx={{ bgcolor: '#ECEADB', color: '#4C4A36', fontWeight: 500, borderRadius: '6px' }} />
//         ))}
//       </Box>

//       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#6B6955' }}>
//         <ChecklistIcon sx={{ fontSize: 16 }} />
//         <Typography sx={{ fontSize: 12 }}>
//           {done}/{total}
//         </Typography>
//         <LinearProgress
//           variant="determinate"
//           value={pct}
//           sx={{ flex: 1, height: 4, borderRadius: 2, bgcolor: '#E6E3D3', '& .MuiLinearProgress-bar': { bgcolor: dot } }}
//         />
//       </Box>

//       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, color: '#6B6955' }}>
//         {/* <Typography sx={{ fontSize: 12, fontWeight: 700, color: '#55533C' }}>{task.key}</Typography> */}
//         <Box title={`${pri.label} priority`} sx={{ display: 'inline-flex', color: pri.color }}>
//           <pri.Icon sx={{ fontSize: 18 }} aria-label={`${pri.label} priority`} />
//         </Box>
//         <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
//           <AccessTimeIcon sx={{ fontSize: 14 }} />
//           <Typography sx={{ fontSize: 12 }}>{formatMinutes(task.timeSpentMinutes)}</Typography>
//         </Box>
//         <Box sx={{ ml: 'auto', display: 'inline-flex', alignItems: 'center', gap: 1 }}>
//           <Typography sx={{ fontSize: 12 }}>{formatDue(task.dueDate)}</Typography>
//           {}
//           <UserAvatar user={user} size={26} />
//         </Box>
//       </Box>
//     </Box>
//   )
// }

// export default function TaskBoard({ tasks, onMove, onOpen, onCreate }: Props) {
//   const handleDragEnd = (result: DropResult) => {
//     const { destination, draggableId } = result
//     if (!destination) return
//     const toStatus = destination.droppableId as StatusId
//     // destination.index is relative to the visible column without the dragged card
//     const column = tasks.filter((t) => t.status === toStatus && t.id !== draggableId)
//     const beforeId = column[destination.index]?.id ?? null
//     onMove(draggableId, toStatus, beforeId)
//   }

//   return (
//     <DragDropContext onDragEnd={handleDragEnd}>
//       <Box sx={{ overflowX: 'auto', pb: 1 }}>
//         <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, minWidth: STATUSES.length * 265 }}>
//           {STATUSES.map((status) => {
//             const column = tasks.filter((t) => t.status === status.id)
//             return (
//               <Droppable droppableId={status.id} key={status.id}>
//                 {(provided, snapshot) => (
//                   <Box
//                     ref={provided.innerRef}
//                     {...provided.droppableProps}
//                     component="section"
//                     aria-label={status.label}
//                     sx={{
//                       flex: '1 1 260px',
//                       position:'relative',
//                       minWidth: 250,
//                       height: 560,
//                       overflow:'auto',
//                       borderRadius: '12px',
//                       p: 1.5,
//                       pt:0,
//                       bgcolor: status.columnBg,
//                       outline: snapshot.isDraggingOver ? `2px dashed ${status.dot}` : '2px solid transparent',
//                       outlineOffset: -2,
//                     }}
//                   >
//                     <Box sx={{ display: 'flex', alignItems: 'center', pt:1.5, bgcolor: status.columnBg, gap: 1, px: 0.5, pb: 1.25, position:'sticky' , top:'0', zIndex:3}}>
//                       <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: status.dot }} />
//                       <Typography
//                         component="h2"
//                         sx={{ fontSize: 12, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: status.ink }}
//                       >
//                         {status.label}
//                       </Typography>
//                       <Chip
//                         size="small"
//                         label={column.length}
//                         sx={{ height: 20, bgcolor: status.pillBg, color: status.ink, fontWeight: 700 }}
//                       />
//                     </Box>

//                     <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
//                       {column.map((task, index) => (
//                         <Draggable draggableId={task.id} index={index} key={task.id}>
//                           {(p, snap) => (
//                             <Box
//                               ref={p.innerRef}
//                               {...p.draggableProps}
//                               {...p.dragHandleProps}
//                               onClick={() => onOpen(task)}
//                             >
//                               <TaskCard task={task} dot={status.dot} isDragging={snap.isDragging} />
//                             </Box>
//                           )}
//                         </Draggable>
//                       ))}
//                       {provided.placeholder}
//                     </Box>

//                     {column.length === 0 && !snapshot.isDraggingOver && (
//                       <Box sx={{ border: '2px dashed #CFCBB5', borderRadius: '10px', p: 3, textAlign: 'center', color: '#6B6955', fontSize: 13 }}>
//                         Drop tasks here
//                       </Box>
//                     )}

//                     {/* <Button
//                       startIcon={<AddIcon />}
//                       onClick={() => onCreate(status.id)}
//                       sx={{ mt: 1, color: status.ink, textTransform: 'none', fontWeight: 600 }}
//                     >
//                       Create task
//                     </Button> */}
//                   </Box>
//                 )}
//               </Droppable>
//             )
//           })}
//         </Box>
//       </Box>
//     </DragDropContext>
//   )
// }

import { Box, Button, Chip, LinearProgress, Typography } from '@mui/material'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import ChecklistIcon from '@mui/icons-material/Checklist'
import AddIcon from '@mui/icons-material/Add'
import { DragDropContext, Draggable, Droppable, type DropResult } from '@hello-pangea/dnd'
import {
  PRIORITIES,
  STATUSES,
  checklistProgress,
  formatDue,
  formatMinutes,
  type StatusId,
  type TodoTask,
} from './Tododata.ts'
import AssigneeStack from './AssineeStack.tsx'

interface Props {
  tasks: TodoTask[] // already filtered
  onMove: (taskId: string, toStatus: StatusId, beforeId: string | null) => void
  onOpen: (task: TodoTask) => void
  onCreate: (status: StatusId) => void
}

function TaskCard({ task, dot, isDragging }: { task: TodoTask; dot: string; isDragging: boolean }) {
  const pri = PRIORITIES[task.priority]
  const { done, total } = checklistProgress(task)
  const pct = total ? (done / total) * 100 : 0

  return (
    <Box
      sx={{
        bgcolor: '#fff',
        border: '1px solid #E2DFD0',
        borderRadius: '10px',
        p: 1.5,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.25,
        cursor: 'grab',
        boxShadow: isDragging ? '0 8px 20px rgba(37,36,26,0.25)' : '0 1px 2px rgba(37,36,26,0.08)',
      }}
    >
      <Box className='d-flex align-items-start' gap={1}>
        <Typography sx={{ fontSize: 14, fontWeight: 600, lineHeight: 1.4, color: '#25241A' }}>{task.title}</Typography>
        <Box title={`${pri.label} priority`} sx={{ display: 'inline-flex', color: pri.color }}>
          <pri.Icon sx={{ fontSize: 18 }} aria-label={`${pri.label} priority`} />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
        {task.labels.map((label) => (
          <Chip key={label} size="small" label={label} sx={{ bgcolor: '#ECEADB', color: '#4C4A36', fontWeight: 500, borderRadius: '6px' }} />
        ))}
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#6B6955' }}>
        <ChecklistIcon sx={{ fontSize: 16 }} />
        <Typography sx={{ fontSize: 12 }}>
          {done}/{total}
        </Typography>
        <LinearProgress
          variant="determinate"
          value={pct}
          sx={{ flex: 1, height: 4, borderRadius: 2, bgcolor: '#E6E3D3', '& .MuiLinearProgress-bar': { bgcolor: dot } }}
        />
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, color: '#6B6955' }}>
        {/* <Typography sx={{ fontSize: 12, fontWeight: 700, color: '#55533C' }}>{task.key}</Typography> */}
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
          <AccessTimeIcon sx={{ fontSize: 14 }} />
          <Typography sx={{ fontSize: 12 }}>{formatMinutes(task.timeSpentMinutes)}</Typography>
        </Box>
        <Box sx={{ ml: 'auto', display: 'inline-flex', alignItems: 'center', gap: 1 }}>
          <Typography sx={{ fontSize: 12 }}>{formatDue(task.dueDate)}</Typography>
          <AssigneeStack ids={task.assigneeIds} size={26} />
        </Box>
      </Box>
    </Box>
  )
}

export default function TaskBoard({ tasks, onMove, onOpen, onCreate }: Props) {
  const handleDragEnd = (result: DropResult) => {
    const { destination, draggableId } = result
    if (!destination) return
    const toStatus = destination.droppableId as StatusId
    // destination.index is relative to the visible column without the dragged card
    const column = tasks.filter((t) => t.status === toStatus && t.id !== draggableId)
    const beforeId = column[destination.index]?.id ?? null
    onMove(draggableId, toStatus, beforeId)
  }

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Box sx={{ overflowX: 'auto', pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, minWidth: STATUSES.length * 265 }}>
          {STATUSES.map((status) => {
            const column = tasks.filter((t) => t.status === status.id)
            return (
              <Droppable droppableId={status.id} key={status.id}>
                {(provided, snapshot) => (
                  <Box
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    component="section"
                    aria-label={status.label}
                    sx={{
                      flex: '1 1 260px',
                      position: 'relative',
                      minWidth: 250,
                      height: 560,
                      overflow: 'auto',
                      borderRadius: '12px',
                      p: 1.5,
                      pt: 0,
                      bgcolor: status.columnBg,
                      outline: snapshot.isDraggingOver ? `2px dashed ${status.dot}` : '2px solid transparent',
                      outlineOffset: -2,
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', pt: 1.5, bgcolor: status.columnBg, gap: 1, px: 0.5, pb: 1.25, position: 'sticky', top: '0', zIndex: 3 }}>
                      <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: status.dot }} />
                      <Typography
                        component="h2"
                        sx={{ fontSize: 12, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: status.ink }}
                      >
                        {status.label}
                      </Typography>
                      <Chip
                        size="small"
                        label={column.length}
                        sx={{ height: 20, bgcolor: status.pillBg, color: status.ink, fontWeight: 700 }}
                      />
                    </Box>

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
                      {column.map((task, index) => (
                        <Draggable draggableId={task.id} index={index} key={task.id}>
                          {(p, snap) => (
                            <Box
                              ref={p.innerRef}
                              {...p.draggableProps}
                              {...p.dragHandleProps}
                              onClick={() => onOpen(task)}
                            >
                              <TaskCard task={task} dot={status.dot} isDragging={snap.isDragging} />
                            </Box>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </Box>

                    {column.length === 0 && !snapshot.isDraggingOver && (
                      <Box sx={{ border: '2px dashed #CFCBB5', borderRadius: '10px', p: 3, textAlign: 'center', color: '#6B6955', fontSize: 13 }}>
                        Drop tasks here
                      </Box>
                    )}

                    {/* <Button
                      startIcon={<AddIcon />}
                      onClick={() => onCreate(status.id)}
                      sx={{ mt: 1, color: status.ink, textTransform: 'none', fontWeight: 600 }}
                    >
                      Create task
                    </Button> */}
                  </Box>
                )}
              </Droppable>
            )
          })}
        </Box>
      </Box>
    </DragDropContext>
  )
}